import React from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import { CampaignAction } from 'redux/actions';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import PageSpinner from 'components/PageSpinner';
import { Button } from 'reactstrap';
import { DateFormat } from 'hooks';
import Filter from './filter';


const Transactions = (props) => {

    const [pagination, setPagination] = React.useState({
        page: 0,
        page_limit: 10,
    });
    const [order, setOrder] = React.useState({
        order_by: `created_at`,
        direction: 'desc'
    });

    const [filterValues, setFilterValues] = React.useState({
        transaction_type: '',
        keyword: '',
        start_date: '',
        end_date: ''
    });


    React.useEffect(() => {
        let payload = {
            page: pagination.page,
            page_limit: pagination.page_limit,
            order_by: order.order_by,
            direction: order.direction,
            transaction_type: filterValues.transaction_type,
            keyword: filterValues.keyword,
            start_date: filterValues.start_date,
            end_date: filterValues.end_date,
        };
        props.getTransactionHistory(payload);
    }, [order, pagination]);

    const handleSearch = (filter) => {
        setFilterValues(filter);
        let payload = {
            page: pagination.page,
            page_limit: pagination.page_limit,
            order_by: order.order_by,
            direction: order.direction,
            transaction_type: filter.transaction_type,
            keyword: filter.keyword,
            start_date: filter.start_date,
            end_date: filter.end_date,
        };
        props.getTransactionHistory(payload);
    }

    const columns = () => {
        const cols = [
            { name: "id", label: "Id" },
            { name: "username", label: "Customer" },
            { name: "campaign_name", label: "Campaign" },
            { name: "amount", label: "Amount" },
            { name: "transaction_type", label: "Transaction Type" },
            { name: "stripe_transaction_id", label: "Transaction Id" },
            { name: "created_at", label: "Transaction Date" },
        ];
        return cols.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    display: (column.name === 'id') ? false : true,
                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (tableMeta.columnData.name === 'transaction_type') ?
                            <Button style={{ width: 100 }} size="sm" color={value === 'credit' ? "primary" : "secondary"} outline disabled>{value}</Button>
                            : (tableMeta.columnData.name === 'created_at') ? DateFormat(value) : value
                    }
                }
            }
        })
    }

    const options = {
        tableId: 'datatable',
        filterType: 'checkbox',
        search: false,
        responsive: "simple",
        filter: false,
        download: false,
        print: false,
        selectableRows: 'none',
        viewColumns: false,
        count: props.totalCount,
        serverSide: (props.serverSide !== undefined) ? props.serverSide : true,
        page: pagination.page,
        rowsPerPage: pagination.page_limit,
        onColumnSortChange: (changedColumn) => {
            setOrder({
                order_by: changedColumn,
                direction: (order.direction === 'asc') ? 'desc' : 'asc'
            })
        },
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPagination({
                        page_limit: pagination.page_limit,
                        page: tableState.page
                    })
                    break;
                case 'changeRowsPerPage':
                    setPagination({
                        page_limit: tableState.rowsPerPage,
                        page: 0,
                    })
                    break;
                default:
                    break
            }
        }
    };


    return (
        <div>
            <Filter handleSearch={handleSearch} />
            {props.isLoading ? <PageSpinner />
                : <DataTables data={props.interestsList} columns={columns()} options={options} />
            }
        </div>
    );
}

export default connect(
    (state) => ({

        loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
        isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
        interestsList: (state.campaign &&
            state.campaign.transactionHistory &&
            state.campaign.transactionHistory.data) ? state.campaign.transactionHistory.data : [],
        totalCount: (state.campaign && state.campaign.transactionHistory &&
            state.campaign.transactionHistory.total) ? state.campaign.transactionHistory.total : 0,
    }),
    (dispatch) => ({
        getTransactionHistory: (payload) => dispatch(CampaignAction.getTransactionHistory(payload)),
    })

)(Transactions);

